/**
 * Booking/pricing flow for a service (plan §8 step 3).
 *
 * `pricing_model` ('slot' | 'subscription') is the source of truth. The legacy
 * `category` (team_sports | individual_sports) and `type` are fallbacks for
 * data not yet carrying pricing_model. "Slot-based" maps to the old team flow,
 * "subscription" to the old individual flow — same entity, different pricing.
 */

export function isSlotBasedService(service) {
  if (!service) return false;
  if (service.pricing_model === 'slot') return true;
  if (service.pricing_model === 'subscription') return false;
  if (service.category === 'team_sports') return true;
  const t = service.type;
  return t === 'cricket_match' || t === 'practice_net' || t === 'open_net';
}

export function isSubscriptionService(service) {
  if (!service) return false;
  if (service.pricing_model === 'subscription') return true;
  if (service.pricing_model === 'slot') return false;
  return service.category === 'individual_sports' || service.type === 'individual_sports';
}

// Back-compat aliases: the team/individual naming maps onto slot/subscription.
export const isTeamSportsService = isSlotBasedService;
export const isIndividualSportsService = isSubscriptionService;
